/* ==========================================================================
   Bubbez — first-order welcome offer bar
   --------------------------------------------------------------------------
   Purpose: the Klaviyo welcome popup hands a subscriber the BOGO + free
   shipping offer. This bar carries that offer with them around the site so
   they do not have to go straight to checkout from the popup.

   It renders ONLY for visitors who arrived on a link carrying
   ?offer=firstorder. Everyone else never sees it, which is what keeps the
   public price anchor intact.

   Also exposes window.BubbezOffer so the free shipping progress bar in
   zoom-navigation-bubbez.js can tell an offer holder apart from a normal
   visitor.
   ========================================================================== */

(function () {
  'use strict';

  var COOKIE      = 'bubbez_offer';
  var VALUE       = 'firstorder';
  var DAYS        = 30;
  var SESSION_KEY = 'bubbez_offer_bar_dismissed';

  var CART_LINK =
    '/cart/45343448400070:2?discount=FIRSTORDER-FREESHIP';

  // Full copy on desktop, short copy on phones, so the bar stays one row deep.
  // "First purchase" is stated up front on purpose. Someone who has already
  // bought cannot use these codes — Shopify refuses them at checkout — so the
  // limit has to be visible BEFORE they click, not discovered afterwards.
  var BAR_TEXT =
    '<span class="bz-offer-bar__full">First purchase offer: ' +
    '<strong>2 boxes, $35.98, shipped FREE.</strong></span>' +
    '<span class="bz-offer-bar__short">First purchase: ' +
    '<strong>2 for $35.98, shipped FREE</strong></span>';
  var BAR_CTA  = 'Claim offer';

  /* ---------- cookie helpers ---------- */

  function readCookie(name) {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split('=');
      if (kv[0] === name) return decodeURIComponent(kv.slice(1).join('='));
    }
    return null;
  }

  function writeCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie =
      name + '=' + encodeURIComponent(value) +
      '; expires=' + d.toUTCString() +
      '; path=/; SameSite=Lax';
  }

  /* ---------- offer state ---------- */

  // Arriving with ?offer=firstorder claims the offer for 30 days.
  try {
    var p = new URLSearchParams(window.location.search).get('offer');
    if (p && p.toLowerCase() === VALUE) writeCookie(COOKIE, VALUE, DAYS);
  } catch (e) { /* older browser, fall through to cookie check */ }

  function isActive() {
    return readCookie(COOKIE) === VALUE;
  }

  window.BubbezOffer = {
    active: isActive,
    cartLink: CART_LINK
  };

  /* ---------- the bar ---------- */

  function dismissed() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; }
    catch (e) { return false; }
  }

  function markDismissed() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) { /* private mode */ }
  }

  function build() {
    var bar = document.createElement('div');
    bar.className = 'bz-offer-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Your welcome offer');

    var text = document.createElement('p');
    text.className = 'bz-offer-bar__text';
    text.innerHTML = BAR_TEXT;

    var cta = document.createElement('a');
    cta.className = 'bz-offer-bar__cta';
    cta.href = CART_LINK;
    cta.textContent = BAR_CTA;

    var close = document.createElement('button');
    close.className = 'bz-offer-bar__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Hide this offer');
    close.innerHTML = '&times;';
    close.addEventListener('click', function () {
      markDismissed();
      bar.remove();
    });

    bar.appendChild(text);
    bar.appendChild(cta);
    bar.appendChild(close);
    return bar;
  }

  function mount() {
    if (!isActive() || dismissed()) return;
    if (document.querySelector('.bz-offer-bar')) return;

    // Placed as a sibling immediately before <main>, not inside it. Horizon
    // targets .content-for-layout > .shopify-section:first-child when the
    // header is transparent; inserting inside <main> would displace that
    // first-child match. As a sibling it sticks under the header and leaves
    // the theme's own layout rules alone.
    var bar = build();
    var main = document.getElementById('MainContent');
    if (main && main.parentNode) {
      main.parentNode.insertBefore(bar, main);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  // Horizon swaps sections without a full page load.
  document.addEventListener('shopify:section:load', mount);
})();
